import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import UserManagement from './UserManagement';
import ReportsView from './ReportsView';
import LiveView from './LiveView';
import GeofenceSettings from './GeofenceSettings';
import SucursalesSettings from './SucursalesSettings';

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState('usuarios');
  const { isDemo } = useAuth();

  return (
    <div className="admin-panel">
      {isDemo && (
        <div style={{
          background: '#f8fafc',
          border: '1px solid #cbd5e1',
          color: '#475569',
          padding: '10px 14px',
          borderRadius: '8px',
          marginBottom: '16px',
          fontSize: '0.85rem',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <span>🛡️ <strong>Modo Demostración:</strong> Estás explorando el panel administrativo en un entorno de prueba aislado y seguro.</span>
        </div>
      )}
      <nav className="admin-nav">
        <button onClick={() => setActiveTab('usuarios')} className={activeTab === 'usuarios' ? 'active' : ''}>👥 Usuarios</button>
        <button onClick={() => setActiveTab('reportes')} className={activeTab === 'reportes' ? 'active' : ''}>📊 Reportes</button>
        <button onClick={() => setActiveTab('vivo')} className={activeTab === 'vivo' ? 'active' : ''}>🔴 En Vivo</button>
        <button onClick={() => setActiveTab('sucursales')} className={activeTab === 'sucursales' ? 'active' : ''}>📍 Sucursales</button>
      </nav>
      <div className="admin-content">
        {activeTab === 'usuarios' && <UserManagement />}
        {activeTab === 'reportes' && <ReportsView />}
        {activeTab === 'vivo' && <LiveView />}
        {activeTab === 'sucursales' && <SucursalesSettings />}
      </div>
    </div>
  );
};

export default AdminPanel;